import { render, staticRenderFns } from "./Cessao.vue?vue&type=template&id=3f3e7920&"
import script from "./Cessao.vue?vue&type=script&lang=js&"
export * from "./Cessao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports